import { ApiConnection } from '../../decorators/@ApiConnection.decorator';
import { InvoiceService } from './invoice.service';
import { DataSource } from "@angular/cdk/collections";
import { IApiSageInvoice, IApiSageInvoiceFilter, IApiSageInvoiceConnection } from 'src/app/shared/modules/graphql/types/types';
import { NefcoPagedDataSource } from 'src/app/shared/helpers/nefco-data-source.class';

export class SageInvoiceDataSource extends NefcoPagedDataSource<IApiSageInvoice, InvoiceService, IApiSageInvoiceConnection> implements DataSource<IApiSageInvoice> {
  @ApiConnection()
  public load(filters?: IApiSageInvoiceFilter[]): Promise<IApiSageInvoiceConnection> {
    return this.service.getSageInvoices(filters, this.listPage).toPromise();
  }
}
